/*
 * @file handle display value attachment caption
 */

// Attachment caption can have a default value (currently it is title from Beethoven's extraction)
// If there is no custom value for attachment caption set in the post, we will display that default value

// This must match the constant set in the Wish model in the backend
// If the custom attachment caption equals to this, we will show a blank string.
// We are using this to avoid having to differentiate between null and blank string in Javascript
const BLANK_ATTACHMENT_CAPTION = '&$$$__BLANK__$$$&'

const attachmentCaptionForDisplay = ({
  postAttachmentCaption,
  defaultCaption,
}: {
  postAttachmentCaption: string | null
  defaultCaption: string
}): string => {
  const captionValue = postAttachmentCaption || defaultCaption || ''
  return captionValue === BLANK_ATTACHMENT_CAPTION ? '' : captionValue
}

export default attachmentCaptionForDisplay
